import React, { useState } from "react";
import { Layout, Menu, Avatar, Dropdown } from "antd";
import { Outlet } from "react-router-dom";
import {
  UserOutlined,
  LogoutOutlined,
  MailOutlined,
  DockerOutlined,
  SettingOutlined,
} from "@ant-design/icons";

import "../css/common.css";
import { ApiURL } from "../../services/apiConstants";
import FloatingFabCompanyModal from "./FloatingFabCompanyModal";
import ChatBot from "../../components/ChatBot";
import SidebarNavigation from "../../components/navigation/SidebarNavigation";
import useUserData from "../../hooks/useUserData";
import HeaderTimeWidget from "../../components/time/HeaderTimeWidget";
import useSubscriptionAccess from "../../hooks/useSubscriptionAccess";
import SubscriptionAccessScreen from "../../components/subscription/SubscriptionAccessScreen";
// import FloatingFabCompanyModal from "./FloatingFabCompanyModal";

const { Header, Sider, Content } = Layout;

const CompanyDashboardLayout = () => {
  const [collapsed, setCollapsed] = useState(false);
  const user = useUserData();
  const access = useSubscriptionAccess(ApiURL.company_modules_com);
  const userData = access.data || user?.data || {};
  const modules = access.subscription?.modules || [];

  const toggleCollapse = () => setCollapsed(!collapsed);

  const logout = () => {
    localStorage.clear();
    window.location = "/";
  };

  if (!access.hasAccess) {
    return <SubscriptionAccessScreen access={access} companyName={userData?.company_details?.name} onLogout={logout} />;
  }

  // USER DROPDOWN
  const userMenu = (
    <Menu>
      <Menu.Item key="time-reference" className="marine-header__time-menu">
        <HeaderTimeWidget variant="menu" showSelector={false} />
      </Menu.Item>
      <Menu.Item key="time-date" icon={<SettingOutlined />}>
        <a href="/utilities/settings/time-date">Settings · Time &amp; Date</a>
      </Menu.Item>
      <Menu.Item onClick={logout} key="logout" icon={<LogoutOutlined />}>
        Logout
      </Menu.Item>
    </Menu>
  );

  // FINAL UI
  return (
    <Layout style={{ height: "100vh", overflow: "hidden" }}>
      <style>
        {`
          .no-scrollbar::-webkit-scrollbar {
            display: none;
          }
          .no-scrollbar {
            -ms-overflow-style: none;
            scrollbar-width: none;
          }
          .flex-column {
            display: flex;
            flex-direction: column;
            height: 100%;
          }
          .scroll-container {
            flex: 1;
            overflow-y: auto;
          }
        `}
      </style>
      <Sider
        width={230}
        collapsible
        collapsed={collapsed}
        onCollapse={toggleCollapse}
        breakpoint="lg"
        collapsedWidth={72}
        className="custom-sider"
        style={{
          height: "100vh",
          background: "linear-gradient(180deg, #08213c 0%, #041628 100%)",
        }}
      >
        <div className="flex-column">
          <div
            className="logo"
            style={{
              flexShrink: 0,
              background: "#091e31",
              padding: "15px 20px",
              borderBottom: "1px solid rgba(255,255,255,0.05)",
            }}
          >
            <h2
              style={{
                color: "#fff",
                margin: 0,
                fontSize: "16px",
                fontWeight: "800",
                letterSpacing: "1px",
              }}
            >
              MARIN-COMPANY
            </h2>
          </div>

          <div className="scroll-container no-scrollbar">
            <SidebarNavigation modules={modules} collapsed={collapsed} />
            <button
              type="button"
              onClick={logout}
              style={{
                width: "calc(100% - 24px)",
                margin: "0 12px 20px",
                padding: "10px 12px",
                border: "1px solid rgba(255,255,255,0.16)",
                borderRadius: 7,
                background: "transparent",
                color: "#dbeafe",
                cursor: "pointer",
                textAlign: "left",
              }}
            >
              <LogoutOutlined style={{ marginRight: collapsed ? 0 : 10 }} />
              {!collapsed && "Logout"}
            </button>
          </div>
        </div>
      </Sider>

      <Layout className="site-layout flex-column" style={{ height: "100vh" }}>
        <Header
          style={{
            padding: "0 24px",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            flexShrink: 0,
            backgroundColor: "#f8fafc",
            boxShadow: "0 2px 10px rgba(0,0,0,0.05)",
            zIndex: 10,
          }}
        >
          <div
            className="marine-header__metadata"
            style={{
              color: "#001529",
              display: "flex",
              alignItems: "center",
              fontSize: "15px",
            }}
          >
            <MailOutlined style={{ marginRight: 8, color: "#E11236" }} />
            <b>Email:</b>{" "}
            <span style={{ marginLeft: 6 }}>{userData?.email}</span>
            <DockerOutlined
              style={{
                marginLeft: 20,
                marginRight: 8,
                color: "#E11236",
                fontSize: "18px",
              }}
            />
            <b>Company:</b>{" "}
            <span style={{ marginLeft: 6 }}>
              {userData?.company_details?.name}
            </span>
            <HeaderTimeWidget />
          </div>

          <div className="marine-header__actions">
            <Dropdown overlay={userMenu} placement="bottomRight">
              <div
                style={{
                  color: "#001529",
                  cursor: "pointer",
                  display: "flex",
                  alignItems: "center",
                  fontSize: "15px",
                  textTransform: "capitalize",
                }}
              >
                <b>Welcome:</b>{" "}
                <span style={{ marginLeft: 6, marginRight: 12 }}>
                  {user?.data.name}
                </span>{" "}
                <Avatar
                  style={{ backgroundColor: "#001529" }}
                  icon={<UserOutlined />}
                />
              </div>
            </Dropdown>
          </div>
        </Header>

        {/* <Content style={{ margin: "0 16px" }}>
          <div style={{ padding: 18, minHeight: 360 }}>
            <Outlet />
          </div>
        </Content> */}

        <Content
          className="scroll-container no-scrollbar"
          style={{ margin: "0 16px", position: "relative" }}
        >
          <div style={{ padding: 15, minHeight: 360 }}>
            <Outlet />
          </div>

          {/* ADD FAB HERE */}
          <FloatingFabCompanyModal />
          <ChatBot apiUrl={ApiURL.company_chatbot} />
        </Content>
      </Layout>
    </Layout>
  );
};

export default CompanyDashboardLayout;
